import { cargas } from './cargas'
import { notificaciones } from './notificaciones'

export const all = {
    pCargas: cargas,
    pNotificaciones: notificaciones
}